export const questions = {
  purpose: {
    100: 'HIGHEST',
    50: 'MODERATE',
    0: 'NOT_AT_ALL',
  },
  happiness: {
    100: 'JOYFUL',
    50: 'CONTENT',
    0: 'NEUTRAL',
  },
  necessity: {
    100: 'ESSENTIAL',
    50: 'USEFUL',
    0: 'NOT_AT_ALL',
  },
  probability: {
    100: 'ITS_HAPPENING',
    75: 'HIGHLY_LIKELY',
    50: 'CONFINDENT',
    25: 'ITS_POSSIBLE',
    0: 'HOPEFULLY',
  },
  giving_legacy: {
    necessity: {
      100: 'ESSENTIAL',
      0: 'NOT_AT_ALL',
    },
    purpose: {
      100: 'HIGHEST',
      50: 'MODERATE',
      0: 'NOT_AT_ALL',
    },
  },
};
